var t={tooltip:"lds-tooltip",visible:"lds-tooltip--visible",caret:"lds-tooltip--caret"};export{t as default};
